import { DomainError } from './errors.js';
import { parseSubject } from './forms/subject.js';

/** Yetki matrisinin sütunları: modül × işlem (mimari belge §7.1). */
export const MODULES = [
  'ism_forms',
  'equipment',
  'maintenance_program',
  'work_records',
  'running_hours',
  'postponements',
  'defects',
  // İş emri (ADR 0029 §3): değiştirilebilir kayıt; iş kaydı düzenlenemediği için ayrı modül
  // [NR496 4.5.3f]. İptal `void`
  'work_orders',
  // Gemi sertifikaları, sörveyler ve klas (ADR 0029 K28, "Sonuçlar"): ofiste sertifika, sayfa,
  // sörvey, bulgu, kalem listesi ve yetki beyanı; gemide yalnız vize, sörveyör teyidi ve gemide
  // düzenlenen sertifika (`create`)
  'vessel_certificates',
  'reports',
  'users',
  'devices',
  'settings',
  // Personel (ADR 0017)
  'crew_certificates',
  'rest_hours',
  // Sefer ve sefer raporları (ADR 0022 §3)
  'voyage',
  // Doküman kütüphanesi ve gemide revizyon teyidi (ADR 0027 §4; plan M8a Task 5). İşlem eşlemesi:
  // view görüntüle, create taslak yükle, edit klasör ve doküman bilgisi, submit onaya gönder,
  // approve onayla ve yayınla, return iade et, void geri çek ya da taslaktan vazgeç, export indir
  // ve bas. Yeni işlem eklenmez.
  'documents',
  'document_acknowledgements',
  // Gemi ağacını düzenleme (sahibin adıyla "documents.tree"; ADR 0037 §11, ADR 0038 §8): yalnız
  // `edit`; varsayılan matriste kapalı. documents modülüne yeni işlem eklenmediği için ayrı modül
  'document_tree',
  // Malzeme kataloğu ve gemi stoğu (ADR 0026)
  'materials',
  'stock',
  // Malzeme talebi, onay, tedarikçi, RFQ ve teklif (ADR 0026 §1, §3)
  'purchasing',
  // HSE raporları: Non-Conformity, Deficiency, Near Miss, Accident (ADR 0049 §6). Kaptan incelemesi
  // ve kapanış kararı `approve`/`return`, yeniden açma `return`
  'hse_reports',
  // Günlük iş planı ve günlük raporlar (ADR 0051 §8)
  'daily_works',
  'daily_reports',
  // Risk değerlendirmesi (ADR 0050 §6): gemide değerlendirme; ofiste şablon kütüphanesi
  'risk_assessments',
  // Mürettebat bordrosu (ADR 0061 §6): ücret kişisel veridir; varsayılan yalnız kaptan ve şirket
  // yöneticisi. `approve` dönemi kapama ve yeniden açma
  'payroll',
  // HSE kayıtlarındaki sağlık verisi (ADR 0062 §1) [GDPR md. 9; KVKK md. 6; MLC A4.1 ¶2]: yalnız
  // `view` (görür ve yazar); `hse_reports`'a yeni işlem eklenmediği için ayrı modül (ADR 0038 §8
  // emsali)
  'hse_medical',
  // Ofisin açtığı şirket uygunsuzluğu (ADR 0062 §2) [ISM 9, 12]: bulut verisi; `approve` kapanış,
  // `return` yeniden açma
  'company_nonconformities',
  // Gemi saati kaydı (ADR 0065 §2): `create` değişiklik girme (vardiya zabiti), `approve` kaptan
  // onayı (parolalı), `void` iptal; ofis görür
  'ship_clock',
  // Şirket risk kütüphanesi (ADR 0089 §5; README R22 "RA Author, RA Reviewer/Approver"): ana veri,
  // Builder, inceleme, yayım ve atama ofiste. `create`/`edit` yazar, `approve`/`return` gözden
  // geçiren; gemi değiştiremez (ADR 0087 §1). Gemide yayımlı sürüm `risk_assessments.view` ile okunur
  'ra_library',
  // Gemide operasyonel risk doğrulaması (ADR 0089 §5): `create` doğrulamayı yapar ve operasyonu
  // yürütür, `approve` yetki verir ve kapatır, `return` iade eder ve reddeder, `void` iptal eder.
  // İş durdurma hücre istemez: gemide atanmış herkesin hakkıdır (SS §1)
  'ra_operations',
  // Kaptan kasası ve Cash to Master (ADR 0093 §7): `create` talep taslağı ve kasa işlemi, `edit`
  // taslak düzeltme (ofiste transfer ve inceleme), `submit` talep gönderimi, `approve` teyit,
  // açılış, sayım ve devir (ofiste CTM kararı), `return` ofiste iade, `void` iptal ve ters kayıt
  'cash',
  // Kumanya (ADR 0099 §4): kumanya kaleminin stok kalemi, lotu ve hareketi. `create` kalem açma,
  // giriş ve tüketim; `edit` seviye ve sayım düzeltmesi; `approve` imha/zayi; `void` kalem kaldırma
  'provisions',
  // Yakıt yönetimi (ADR 0117 §12): tank, alım, transfer, ölçüm ve düzeltme gemi verisidir; yakıt
  // ana kaydı şirket verisidir (`create`/`edit`/`void` ofiste). `submit` onaya gönderme, `approve`
  // gemide onay (başmühendis, kaptan), `return` iade, `void` ters kayıt ya da kaldırma
  'fuel',
  // MRV / ETS (ADR 0117 §12): kapsam, parametre setleri, hesap ve dönem kilidi. Görme kısıtlı:
  // yalnız hücresi olan rol görür. `create`/`edit` MRV sorumlusu, `approve` şirket onaylayıcısı,
  // `export` doğrulayıcı paketi
  'mrv',
  // Tatbikat yönetimi (ADR 0128 §5): Master Library ofiste (`create`/`edit`/`void`); plan, icra ve
  // kapanış gemide (`create`/`edit`/`submit`, kaptan `approve`/`return`); ofiste varyant ve bulgu
  // değerlendirmesi (`approve`/`return`), rapor `export`
  'drills',
  // Dry dock ve Pre-Docking Inspection (ADR 0129 §8): kütüphane ofiste (`create`/`edit`/`void`,
  // yayım = taksonomi onayı `approve`); proje, denetim, bulgu ve iş gemide (`create`/`edit`/
  // `submit`, kaptan ve başmühendis teknik inceleme `approve`/`return`); ofiste iş onayı ve
  // doğrulama (`approve`/`return`), rapor `export`
  'drydock',
  // Personel kartının sağlık bilgisi (ADR 0158 §2) [KVKK md. 6; GDPR md. 9; MLC A4.1 ¶2]: `view`
  // görür (her görüntüleme `audit_log`'a girer), `edit` girer ve düzeltir. `users`'a yeni işlem
  // eklenmediği için ayrı modül (`hse_medical` emsali, ADR 0062 §1)
  'crew_medical',
  // Personel ofis notları (ADR 0159; sahip 2026-11-04 B4): ofisin değerlendirme, geri bildirim ve
  // notu; kişiye ve gemiye gösterilmez. `view` okur, `create` yazar, `edit` düzeltir (yeni sürüm),
  // `void` gerekçeyle geri çeker, `export` KVKK m.11 dışa aktarımı. Gizlilik kısıtlıdır: ofiste
  // yalnız hücresi olan rol görür (`OFFICE_PRIVACY_MODULES`)
  'crew_notes',
] as const;
export type Module = (typeof MODULES)[number];

/**
 * Görme izni olmayan kullanıcıdan menüde de gizlenen modüller (ADR 0061 §6). Oturum bilgisi
 * kişinin görebildiklerini (`viewableModules`) verir; arayüz gerisini gizler.
 */
export const VIEW_RESTRICTED_MODULES = [
  'payroll',
  'cash',
  // MRV / ETS: hesap sonuçları ve kapsam kararları (ADR 0117 §12)
  'mrv',
] as const satisfies readonly Module[];
export type ViewRestrictedModule = (typeof VIEW_RESTRICTED_MODULES)[number];

export const ACTIONS = [
  'view',
  'create',
  'edit',
  'submit',
  'approve',
  'return',
  'void',
  'export',
] as const;
export type Action = (typeof ACTIONS)[number];

/** Hücre değeri: izin yok / kendi kayıtları / gemi / filo (ofis rolleri). */
export const SCOPES = ['none', 'own', 'vessel', 'fleet'] as const;
export type Scope = (typeof SCOPES)[number];

export interface PermissionCell {
  roleId: string;
  module: Module;
  action: Action;
  scope: Scope;
  /**
   * Yalnız ISM formları: `folder:<node_key>` (kategori) ya da `document:<uuid>` (tek form); boşsa
   * modülün tamamı (ADR 0042 §8) [sorular #38, #233].
   */
  subject?: string;
}

export interface PermissionMatrix {
  version: number;
  cells: readonly PermissionCell[];
  /** Uyarılı kurallar için zorunlu gerekçeler; anahtar `validatePermissionMatrix` uyarısındaki `key`. */
  justifications?: Readonly<Record<string, string>>;
}

export interface RoleInfo {
  id: string;
  /** PMS sorumlusu (başmühendis) rolü mü [NR467 Pt A Ch 2 App 1 2.1.2]. Rol rütbeden bağımsızdır. */
  pmsResponsible: boolean;
}

export interface PermissionActor {
  userId: string;
  /** Kişinin hedef gemide (ya da ofiste) geçerli rolleri. */
  roleIds: readonly string[];
  /** Kişinin atandığı gemiler. */
  vesselIds: readonly string[];
}

export interface PermissionTarget {
  /** Kaydın gemisi; şirket verisinde `null`. */
  vesselId: string | null;
  /** Kaydı oluşturan; yeni kayıtta işlemi yapan kişi. */
  ownerId?: string;
}

export interface PermissionRequest {
  actor: PermissionActor;
  module: Module;
  action: Action;
  target: PermissionTarget;
  /**
   * Kaydın konu zinciri, yakından uzağa (`subjectChain`; ADR 0042 §8): zincirde ilk eşleşen özgü
   * hücre kazanır, hiçbiri yoksa modül hücresi. Verilmezse yalnız modül hücresine bakılır.
   */
  subjects?: readonly string[];
}

export interface PermissionDecision {
  allowed: boolean;
  /** Kararı veren en geniş kapsam. */
  scope: Scope;
}

const RANK: Readonly<Record<Scope, number>> = { none: 0, own: 1, vessel: 2, fleet: 3 };

/**
 * Hiçbir role verilemeyen hücreler (mimari belge §7.1 "Değiştirilemeyen ve uyarılı kurallar"):
 * değiştirilemez kayıtlar düzenlenemez ve raporlar yalnız görüntülenip dışa aktarılır.
 */
const NON_GRANTABLE: ReadonlyArray<{ module: Module; actions: readonly Action[]; source: string }> =
  [
    // Raporlanmış PMS iş kaydı değişmez [NR496 4.5.3f]; düzeltme iptal + yeni kayıtla (§7.4)
    { module: 'work_records', actions: ['edit'], source: 'NR496 4.5.3f' },
    // Çalışma saati okumaları ve ertelemeler değiştirilemez kayıtlardır (mimari belge §9.3)
    { module: 'running_hours', actions: ['edit'], source: 'mimari belge §9.3' },
    { module: 'postponements', actions: ['edit'], source: 'NR496 4.5.3d' },
    // Değişiklik kaydı ve izlenebilirlik raporları değiştirilemez [NR496 4.6]
    {
      module: 'reports',
      actions: ['create', 'edit', 'submit', 'approve', 'return', 'void'],
      source: 'NR496 4.6',
    },
    // Revizyon teyidi değiştirilemez bir beyandır (ADR 0027 §11)
    { module: 'document_acknowledgements', actions: ['edit', 'void'], source: 'ADR 0027 §11' },
    // Gemi ağacının tek işlemi düzenlemedir; görme documents.view'dadır (ADR 0038 §8)
    {
      module: 'document_tree',
      actions: ['view', 'create', 'submit', 'approve', 'return', 'void', 'export'],
      source: 'ADR 0038 §8',
    },
    // Sağlık verisinin tek işlemi görmedir; yazma da bu yetkiyle (ADR 0062 §1)
    {
      module: 'hse_medical',
      actions: ['create', 'edit', 'submit', 'approve', 'return', 'void', 'export'],
      source: 'ADR 0062 §1',
    },
    // Personel sağlık bilgisinin işlemleri görme ve düzenlemedir (ADR 0158 §2)
    {
      module: 'crew_medical',
      actions: ['create', 'submit', 'approve', 'return', 'void', 'export'],
      source: 'ADR 0158 §2',
    },
    // Şirket uygunsuzluğu gönderim ve iptal adımsızdır (ADR 0062 §2)
    { module: 'company_nonconformities', actions: ['submit', 'void'], source: 'ADR 0062 §2' },
    // Gemi saati değişikliği değiştirilemez bir kayıttır; düzeltme yeni kayıttır (ADR 0065 §1)
    {
      module: 'ship_clock',
      actions: ['edit', 'submit', 'return', 'export'],
      source: 'ADR 0065 §1',
    },
    // Kütüphanede gönderim yazarın `edit`'idir, iptal yoktur (yayımlı sürüm değişmez; ADR 0087 §3)
    { module: 'ra_library', actions: ['submit', 'void'], source: 'ADR 0089 §5' },
    // Doğrulamanın cevapları ve olayları değiştirilemez; gönderim doğrulamayı yapanındır (ADR 0089 §5)
    { module: 'ra_operations', actions: ['edit', 'submit'], source: 'ADR 0089 §5' },
    // Ofis notu onay akışsızdır; düzeltme yeni sürüm, geri çekme gerekçeli (ADR 0159)
    { module: 'crew_notes', actions: ['submit', 'approve', 'return'], source: 'ADR 0159' },
  ];

/** Bakım programını güncelleme izinleri: başmühendis dışındaki role verilirse gerekçe istenir. */
const MAINTENANCE_PROGRAM_UPDATE: readonly Action[] = ['create', 'edit', 'void'];

/**
 * Hücre hiçbir role verilemiyorsa kuralın kaynağı (ör. `NR496 4.5.3f`), verilebiliyorsa `null`.
 * Matris editörü verilemeyen hücreyi kilitli ve açıklamalı gösterir (ADR 0042 §24).
 */
export function nonGrantableReason(module: Module, action: Action): string | null {
  return (
    NON_GRANTABLE.find((rule) => rule.module === module && rule.actions.includes(action))?.source ??
    null
  );
}

/**
 * Görme izni verilebilen modüller: `view` işlemi verilemeyenler (`document_tree`) dışındaki bütün
 * modüller, kayıt sırasıyla. Oturum bilgisinin `viewableModules`'ı ve şirket yöneticisinin
 * varsayılan görme hücreleri buradan türer; yeni modül eklenince kendiliğinden girer (ADR 0067).
 */
export function viewGrantableModules(): Module[] {
  return MODULES.filter((module) => nonGrantableReason(module, 'view') === null);
}

/**
 * Uyarılı hücrenin gerekçe anahtarı (`justifications` içinde): bakım programını güncelleme yetkisi
 * PMS sorumlusu olmayan role verilirse [NR467 Pt A Ch 2 App 1 2.1.2; IACS UR Z20 1.3.3]. Hücre
 * uyarılı değilse ya da kapsamı `none` ise `null`.
 */
export function justificationKeyFor(
  cell: Pick<PermissionCell, 'roleId' | 'module' | 'action' | 'scope'>,
  role: RoleInfo | undefined,
): string | null {
  if (cell.scope === 'none' || !role || role.pmsResponsible) return null;
  if (cell.module !== 'maintenance_program' || !MAINTENANCE_PROGRAM_UPDATE.includes(cell.action)) {
    return null;
  }
  return `maintenance_program.${cell.action}:${cell.roleId}`;
}

export interface MatrixWarning {
  key: string;
  code: 'MAINTENANCE_PROGRAM_NON_PMS_ROLE';
  roleId: string;
}

/**
 * Matris editörünün zorladığı kurallar. Verilemeyen hücre hata verir; uyarılı kural için
 * `justifications` içinde gerekçe yoksa hata verir. Gerekçeli uyarılar döner (raporlarda görünür).
 */
export function validatePermissionMatrix(
  matrix: PermissionMatrix,
  roles: readonly RoleInfo[],
): MatrixWarning[] {
  if (!Number.isInteger(matrix.version) || matrix.version < 1) {
    throw new DomainError('INVALID_MATRIX_VERSION');
  }
  const roleById = new Map(roles.map((role) => [role.id, role]));
  const seen = new Set<string>();
  const warnings: MatrixWarning[] = [];

  for (const cell of matrix.cells) {
    const role = roleById.get(cell.roleId);
    if (!role) throw new DomainError('UNKNOWN_ROLE', cell.roleId);
    if (cell.subject !== undefined && cell.module !== 'ism_forms') {
      throw new DomainError('SUBJECT_ONLY_FOR_FORMS', `${cell.module}.${cell.action}`);
    }
    // Konu biçimi: folder:<node_key> ya da document:<uuid> (ADR 0042 §8) [sorular #233]
    if (cell.subject !== undefined) parseSubject(cell.subject);
    const id = `${cell.roleId}|${cell.module}|${cell.action}|${cell.subject ?? ''}`;
    if (seen.has(id)) throw new DomainError('DUPLICATE_CELL', id);
    seen.add(id);
    if (cell.scope === 'none') continue;

    const forbidden = nonGrantableReason(cell.module, cell.action);
    if (forbidden) {
      throw new DomainError('NON_GRANTABLE_CELL', `${cell.module}.${cell.action} [${forbidden}]`);
    }
    const key = justificationKeyFor(cell, role);
    if (key) {
      // NR467 Pt A Ch 2 App 1 [2.1.2]; IACS UR Z20 1.3.3
      if (!matrix.justifications?.[key]?.trim()) {
        throw new DomainError('JUSTIFICATION_REQUIRED', key);
      }
      warnings.push({ key, code: 'MAINTENANCE_PROGRAM_NON_PMS_ROLE', roleId: cell.roleId });
    }
  }
  return warnings;
}

function cellScope(matrix: PermissionMatrix, roleId: string, request: PermissionRequest): Scope {
  const match = (subject: string | undefined) =>
    matrix.cells.find(
      (cell) =>
        cell.roleId === roleId &&
        cell.module === request.module &&
        cell.action === request.action &&
        cell.subject === subject,
    );
  // Özgü hücre modül hücresinin önüne geçer (ADR 0003 §1); zincirde yakından uzağa ilk eşleşen
  // kazanır, `none` değeri modül hücresini de kapatır (ADR 0042 §8) [sorular #233]
  for (const subject of request.subjects ?? []) {
    const specific = match(subject);
    if (specific) return specific.scope;
  }
  return match(undefined)?.scope ?? 'none';
}

function covers(scope: Scope, request: PermissionRequest): boolean {
  const { actor, target } = request;
  switch (scope) {
    case 'none':
      return false;
    case 'fleet':
      return true;
    case 'vessel':
      return target.vesselId !== null && actor.vesselIds.includes(target.vesselId);
    case 'own':
      return (
        target.vesselId !== null &&
        actor.vesselIds.includes(target.vesselId) &&
        (target.ownerId ?? actor.userId) === actor.userId
      );
  }
}

/**
 * Yetki matrisini değerlendirir (mimari belge §7.1, §10.3). Gemi sunucusu ve bulut aynı
 * fonksiyonu kullanır. Kişinin rollerinden kaydı kapsayan herhangi biri yeterlidir.
 */
export function evaluatePermission(
  matrix: PermissionMatrix,
  request: PermissionRequest,
): PermissionDecision {
  const forbidden = NON_GRANTABLE.some(
    (rule) => rule.module === request.module && rule.actions.includes(request.action),
  );
  if (forbidden) return { allowed: false, scope: 'none' };
  let best: Scope = 'none';
  let allowed = false;
  for (const roleId of request.actor.roleIds) {
    const scope = cellScope(matrix, roleId, request);
    if (RANK[scope] > RANK[best]) best = scope;
    if (covers(scope, request)) allowed = true;
  }
  return { allowed, scope: best };
}

/**
 * Değişiklik, taşıdığı matris sürümüne göre değerlendirilir (mimari belge §6.3 madde 4, §7.1).
 * Ofiste sonradan yapılan matris değişikliği gemide meşru girilmiş kaydı geçersiz kılmaz.
 */
export function evaluatePermissionAtVersion(
  matrices: ReadonlyMap<number, PermissionMatrix>,
  matrixVersion: number,
  request: PermissionRequest,
): PermissionDecision {
  const matrix = matrices.get(matrixVersion);
  if (!matrix) throw new DomainError('MATRIX_VERSION_UNKNOWN', String(matrixVersion));
  return evaluatePermission(matrix, request);
}
